export const isCurrentNotificationPermissionDefault = () => {
  const permission = localStorage.getItem('notificationPermission');

  return (
    window?.Notification?.permission === 'default' && permission !== 'denied'
  );
};

export const setNotificationPermissionDenied = () => {
  localStorage.setItem('notificationPermission', 'denied');
};

export const requestNotificationPermission = async (): Promise<void> => {
  if (window?.Notification) {
    try {
      const notificationPermission =
        await window.Notification?.requestPermission?.();
      localStorage.setItem('notificationPermission', notificationPermission);
    } catch (error) {
      console.log('Unable to request notification permissions');
      localStorage.setItem('notificationPermission', 'denied');
    }
  } else {
    // The browser does not support notifications
    localStorage.setItem('notificationPermission', 'denied');
  }
};

export const showNotification = (title: string, message: string): void => {
  if (window?.Notification?.permission === 'granted') {
    new window.Notification(title, {
      body: message,
      icon: '/static/favicon/favicon-32x32.ico',
    });
  }
};
